import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RequestOptions, Response } from '@angular/http';

import { Observable } from 'rxjs';



import { GestaoPcaService } from './gestao-pca-service';
import { UtilService } from './util-service';
/*
  Generated class for the ProcessosCorrelatosService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ProcessosCorrelatosService {

  constructor(http: HttpClient,
    private gestaoPcaService: GestaoPcaService,
    private utilService: UtilService) {
  }

  public listarTodasEntidades(): Observable<any> {
    let urlObtencaoDados: string = "processoscorrelatos/listarEntidadesProcessos";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public listarTipoResponsaveis(): Observable<any> {
    let urlObtencaoDados: string = "cargo/listarCargosSAP ";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  // Listar processo correlatos por Ano e entidade
  public listarProcessos(anoExercicio, entidade, idPCA): Observable<any> {
    let urlObtencaoDados: string = encodeURI("processoscorrelatos/listarProcessos?anoExercicio=" + anoExercicio + "&entidade=" + entidade + "&idPca=" + idPCA);
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public importarProcessosCorrelatos(jsonObjeto): Observable<any> {
    let urlObtencaoDados: string = "processoscorrelatos/importarProcessos";
    return this.utilService.postJSON(urlObtencaoDados, jsonObjeto);
  }

  public buscarNomeEntidade(idEntidade): Observable<any> {
    let urlObtencaoDados: string = "processoscorrelatos/buscarNomeEntidade/" + idEntidade;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarProcessosCorrelatos(jsonObjeto): Observable<any> {
    let urlObtencaoDados: string = "processoscorrelatos/importarProcessos ";
    return this.utilService.postJSON(urlObtencaoDados, jsonObjeto);
  }
}



// WEBPACK FOOTER //
// ./src/providers/processos-correlatos-service.ts